import type { ReactNode } from 'react';
import logoUrl from '@sakhtar/design-system/assets/logo/sakhtar-white-logo.svg';
import { AuthHeroPanel } from './AuthHeroPanel.js';

/**
 * The tenant credential screens' shell (Sakhtar Login.dc.html): desktop is
 * the 50/50 hero + 392px form column, mobile is the brand header band over a
 * vertically centred form. Shared by the login screen and password recovery
 * so both read as one family.
 */
export function TenantAuthFrame({
  isDesktop,
  children,
}: {
  readonly isDesktop: boolean;
  readonly children: ReactNode;
}) {
  if (!isDesktop) {
    return (
      <div
        className="sk-app sk-auth-mobile"
        dir="rtl"
        style={{
          width: '100%',
          minHeight: '100dvh',
          background: 'var(--sk-bg-canvas)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            flex: '0 0 auto',
            position: 'relative',
            overflow: 'hidden',
            background: 'var(--sk-brand-800, #23277a)',
            padding: '52px 24px 30px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
          }}
        >
          <div
            aria-hidden="true"
            style={{
              position: 'absolute',
              bottom: -160,
              insetInlineEnd: -120,
              width: 420,
              height: 420,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(120,170,255,.24), rgba(120,170,255,0) 66%)',
              pointerEvents: 'none',
            }}
          />
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={logoUrl} alt="" style={{ height: 32, width: 'auto', display: 'block' }} />
            <span style={{ fontSize: 19, fontWeight: 700, color: '#ffffff' }}>ساختار سیستم</span>
          </div>
          <span style={{ position: 'relative', fontSize: 13, color: 'rgba(255,255,255,.72)' }}>
            محیط ابری یکپارچه
          </span>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 24,
            padding: '28px 24px',
          }}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      className="sk-app"
      dir="rtl"
      style={{ width: '100vw', height: '100dvh', background: 'var(--sk-bg-canvas)' }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          direction: 'ltr',
        }}
      >
        <AuthHeroPanel />
        <div
          style={{
            direction: 'rtl',
            display: 'grid',
            placeContent: 'center',
            background: 'var(--sk-bg-canvas)',
            padding: '0 40px',
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              width: 392,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: 26,
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
